import { Grid, Skeleton } from '@mui/material';

export const StatisticsMemberGrowthSkeleton = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Skeleton variant='text' animation='wave' sx={{ height: '44px', width: '60%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '38px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '38px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '38px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant='text' animation='wave' sx={{ height: '32px', width: '95%' }} />
      </Grid>
    </Grid>
  );
};
